/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArtistAlias
 */
export interface ArtistAlias {
    /**
     * 
     * @type {string}
     * @memberof ArtistAlias
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistAlias
     */
    stageName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistAlias
     */
    manualStageName: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArtistAlias
     */
    readonly type?: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistAlias
     */
    readonly sourceIds?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistAlias
     */
    createdBySystem?: boolean;
}

/**
 * Check if a given object implements the ArtistAlias interface.
 */
export function instanceOfArtistAlias(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "manualStageName" in value;

    return isInstance;
}

export function ArtistAliasFromJSON(json: any): ArtistAlias {
    return ArtistAliasFromJSONTyped(json, false);
}

export function ArtistAliasFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistAlias {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'stageName': json['stageName'],
        'manualStageName': json['manualStageName'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'sourceIds': !exists(json, 'source_ids') ? undefined : json['source_ids'],
        'createdBySystem': !exists(json, 'created_by_system') ? undefined : json['created_by_system'],
    };
}

export function ArtistAliasToJSON(value?: ArtistAlias | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'stageName': value.stageName,
        'manualStageName': value.manualStageName,
        'created_by_system': value.createdBySystem,
    };
}

